import { z } from 'zod';
/**
 * Enums / types du domaine — source unique de vérité front + back.
 * Chaque enum est un schéma Zod (validation) ET un type dérivé. Les valeurs sont
 * alignées sur les enums PostgreSQL créés par `0001_init.sql`.
 */
/**
 * Rôle utilisateur (rôles à capacités, cf. SPEC XFILE-07) :
 *  - `superadmin` : système (paramétrage, logs, maintenance) ;
 *  - `admin` : rôle par défaut d'un compte créé — lire/écrire des fichiers,
 *    créer & détruire des dossiers ;
 *  - `user` : lecture seule (consulter et parcourir le stockage).
 */
export const userRoleSchema = z.enum(['superadmin', 'admin', 'user']);
/** Langue de l'interface (i18n UI). */
export const localeSchema = z.enum(['fr', 'de', 'en']);
/** Préférence de thème (défaut applicatif : `system`). */
export const themeSchema = z.enum(['light', 'dark', 'system']);
//# sourceMappingURL=enums.js.map